module.exports = __webpack_public_path__ + "img/jesus-with-a-halo-traditional-tattoo-594.jpg";